import { render, staticRenderFns } from "./alt-check-box.vue?vue&type=template&id=7f39bbe0&"
import script from "./alt-check-box.vue?vue&type=script&lang=ts&"
export * from "./alt-check-box.vue?vue&type=script&lang=ts&"
import style0 from "./alt-check-box.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports